import React from "react";

const Footer = () => {
  return (
    <div>
      <footer className="bottom-0 w-full text-xl font-bold text-black-800 bg-gray-100 border border-gray-300  text-center shadow-lg">
        <small>
          <a href="https://ebhashasetu.com/" target="_blank" rel="noopener noreferrer"> Copyright © Siasat Daily, {new Date().getFullYear()}. All Rights Reserved | Powered by eBhasha Setu</a>
        </small>
      </footer>
    </div>
  );
};

export default Footer;